import { useAuth } from "../../providers/authprovider";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  faUsers,
  faBuilding,
  faCalendarAlt,
  faFileAlt,
  faMicrochip,
  faUserTie,
  faPeopleGroup,
  faTags,
  faBoxes,
  faBook
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ICONS_MAP = {
  clients: faUsers,
  buildings: faBuilding,
  calendar: faCalendarAlt,
  protocols: faFileAlt,
  devices: faMicrochip,
  workers: faUserTie,
  teams: faPeopleGroup,
  offers: faTags,
  assortments: faBoxes,
  instructions: faBook,
};

const ENDPOINTS_ARRAY = [
  { endpoint: "clients", name: "Kontrahenci" },
  { endpoint: "buildings", name: "Obiekty" },
  { endpoint: "calendar", name: "Terminarz" },
  { endpoint: "protocols", name: "Protokoły" },
  { endpoint: "devices", name: "Urządzenia" },
  { endpoint: "workers", name: "Pracownicy" },
  { endpoint: "teams", name: "Ekipy" },
  { endpoint: "offers", name: "Oferty" },
  { endpoint: "assortments", name: "Asortymenty" },
  { endpoint: "instructions", name: "Instrukcje" },
];

export default function Dashboard() {
  const auth = useAuth();
  const { user } = auth;

  return (
    <Container className="py-4">
      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {ENDPOINTS_ARRAY.map(({ endpoint, name }) => {
          const privilege = user?.getPrivilege(endpoint);
          if (!privilege?.view) return null;

          return (
            <Col key={endpoint}>
              <Link to={`/${endpoint}`} className="text-decoration-none text-dark">
                <Card className="h-100 shadow dashboard-tile border-0 hover-shadow text-center p-3">
                  <FontAwesomeIcon icon={ICONS_MAP[endpoint]} size="2x" className="mb-2 text-primary" />
                  <Card.Body>
                    <Card.Title className="fs-5">{name}</Card.Title>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}
